import { render, staticRenderFns } from "./MessageCardDescription.vue?vue&type=template&id=9ea46660&scoped=true&"
import script from "./MessageCardDescription.vue?vue&type=script&lang=ts&"
export * from "./MessageCardDescription.vue?vue&type=script&lang=ts&"
import style0 from "./MessageCardDescription.vue?vue&type=style&index=0&id=9ea46660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea46660",
  null
  
)

export default component.exports